import axios from 'axios';
import store from 'store';
import { tokenSelector } from 'config/selectors';


const insertAuthorizationInterceptor = () =>
  axios.interceptors.request.use(
    request => {
      const accessToken = tokenSelector(store.getState());
      if (accessToken) {
        request.headers.Authorization = `Token ${accessToken}`;
      }
      return request;
    },
    error => Promise.reject(error),
  );

export const configureAxios = () => {
  insertAuthorizationInterceptor();
};
